<template>
  <el-container v-loading="!loading">
    <template v-if="loading">
      <el-aside class="aside" v-if="isReady">
        <layout-nav :isReady="isReady" />
      </el-aside>
      <el-main class="main">
        <template v-if="isReady">
          <!-- <layout-total /> -->
          <!-- <layout-tags @cut-load="onCutLoad" v-show="false" /> -->
          <div class="layoutMain" v-loading="cutLoading">
            <router-view v-slot="{ Component, route }">
              <keep-alive>
                <template v-if="!cutLoading">
                  <component class="layoutViews" :is="Component" :key="route.path + getThisCompany.subId" />
                </template>
              </keep-alive>
            </router-view>
            <component class="layoutViews" v-for="item in realIframeList" :key="item.value + getThisCompany.subId" :is="item.meta.iframeComponent" v-show="$route.path == item.value"></component>
            <notCreate />
          </div>
        </template>
        <template v-else>
          <div class="flex">
            <img src="@/assets/icon-empty.png" alt="" />
            <span>请选分配企业</span>
          </div>
        </template>
      </el-main>
    </template>
  </el-container>
</template>

<script setup lang="ts">
import LayoutTags from "../layoutTags.vue";
import notCreate from "@/components/notCreate/notCreate.vue";
//import LayoutTotal from "../layoutTotal.vue";
import LayoutNav from "../layoutNav.vue";
import useIframe from "@/hooks/iframe/useIframe";
import { onMounted, ref, watch, watchPostEffect, computed } from "vue";
import useInitData from "@/hooks/useInitData";
import { onBeforeRouteUpdate } from "vue-router";
import { useStore } from "vuex";
const { realIframeList, effectList } = useIframe();
const store = useStore();
const { initData, isPower } = useInitData();
const loading = ref(false);
const getThisCompany = computed(() => store.getters.getThisCompany);

onMounted(async () => {
  await initData();
  loading.value = true;
});
const isReady = ref(false);
watchPostEffect(() => {
  const list = store.getters.getTagList;
  isReady.value = !!list.length;
  console.log(isReady.value, "isReadyisReadyisReadyisReadyisReady");
});
const cutLoading = ref(true); // 切换loading, 控制加载顺序
const onCutLoad = (e: boolean) => {
  cutLoading.value = e;
  // 手动刷新加载iframe, 需延迟执行,否则得不到信息
  if (!e) setTimeout(effectList);
};
onBeforeRouteUpdate((to) => {
  isPower(store.getters.getCurrentPower, to.name as string);
});
watch(
  getThisCompany,
  (newData) => {
    console.log(newData, "newData");
    onCutLoad(false);
  },
  { immediate: true }
);
</script>

<style lang="less" scoped>
.aside {
  width: @navWidth;
}
.main {
  background: @mainBg;
  padding: @padding;
  display: flex;
  flex-direction: column;
  .layoutMain {
    background-color: #fff;
    flex: 1;
    overflow: auto;
    position: relative;
  }
  :deep(.layoutViews) {
    box-sizing: border-box;
    height: 100%;
    padding: 20px 0;
    overflow: hidden;
    display: flex;
  }
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    img {
      width: 20vw;
      min-width: 400px;
    }
    span {
      margin-top: 10px;
      color: #666;
      font-size: 1vw;
    }
  }
}
</style>
